// extracted by mini-css-extract-plugin
export default {"order_price":"OrderPrice_order_price__OwLzp","label":"OrderPrice_label__LcoQ0","value":"OrderPrice_value__maiFG"};